import { Division } from '../../types'
import { fetchDivisions } from '../../services/divisions.service'
import createBaseStore from '../createStoreHelper'
import { getters } from './division.getters'

export const DivisionModule = createBaseStore<Division>({
  resourceName: 'division',
  apiCalls: {
    fetchAllApiCall: fetchDivisions
  }
})

DivisionModule.getters = { ...DivisionModule.getters, ...getters }
